export const TERMS_AND_CONDITIONS_URL = 'https://audiencerate.com/terms-and-conditions';
export const PRIVACY_POLICY_URL = 'https://audiencerate.com/privacy-mdp';
